import { isValidElement, useCallback, useEffect, cloneElement } from "react";
import { List } from "react-virtualized";
import React from "react";

const VirtualizedListbox = React.forwardRef(({ children, role, itemSize = 45, ...other }, ref) => {
    const [width, setDivWidth] = React.useState(300);
    const items = React.Children.toArray(children);
    const itemCount = items.length;
    const listHeight = itemSize * itemCount;
    const handleResize = useCallback(() => {
        const element = document.getElementById(other.id);
        if (!element) return;
        setDivWidth(element.offsetWidth);
    }, []);
    useEffect(() => {
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const renderRowItem = (listRowProps) => {
        if (isValidElement(items[listRowProps.index])) {
            return cloneElement(items[listRowProps.index], {
                style: listRowProps.style,
            });
        }
        return null;
    };
    return (
        <div ref={ref}>
            <div {...other}>
                <List
                    height={Math.min(listHeight, 250)}
                    width={width}
                    rowHeight={itemSize}
                    overscanCount={5}
                    rowCount={itemCount}
                    rowRenderer={renderRowItem}
                    role={role}
                />
            </div>
        </div>
    );
});

export default VirtualizedListbox;
